import { functions } from "../../../firebase";
import { FirebaseError } from "firebase/app";
import { deleteField, FieldValue, Timestamp } from "firebase/firestore";
import { httpsCallable, HttpsCallableResult } from "firebase/functions";
import { removeEmptyFields, isObject } from "utils";

export function callFunction(
  name: string,
  data: any
): Promise<HttpsCallableResult<any>> {
  const func = httpsCallable(functions, name);
  return func(data);
}

export function now(): Timestamp {
  return Timestamp.now();
}

export function dateToTimestamp(date: Date): Timestamp {
  return Timestamp.fromDate(date);
}

export function dateToTimestampOrNow(date?: Date): Timestamp {
  return date ? Timestamp.fromDate(date) : Timestamp.now();
}

export const timestampObjectToDate = (date: {
  _seconds: number;
  _nanoseconds: number;
}): Date => {
  return new Timestamp(date._seconds, date._nanoseconds).toDate();
};

export function markFieldToDelete(): any {
  return deleteField();
}

export function toDocumentData(data: any) {
  const keys = Object.keys(data);

  if (keys.includes("createdAt"))
    data.createdAt = dateToTimestampOrNow(data.createdAt);
  if (keys.includes("modifiedAt"))
    data.modifiedAt = dateToTimestampOrNow(data.modifiedAt);

  // remove empty values inside Arrays e Objects and convert dates
  keys.forEach((field) => {
    let value = data[field];

    if (value && value instanceof FieldValue) {
      return;
    }

    if (value && value instanceof Date) {
      data[field] = dateToTimestamp(value);
    } else if (Array.isArray(value)) {
      data[field] = toDocumentData(value);
    } else if (isObject(value)) {
      data[field] = toDocumentData(value);
    }
  });

  return removeEmptyFields(data);
}

export function fromDocumentData(data: any) {
  const keys = Object.keys(data);

  // verify values inside Arrays e Objects and convert timestamps to date
  keys.forEach((field) => {
    let value = data[field];

    if (value && value instanceof Timestamp) {
      data[field] = value.toDate();
    } else if (Array.isArray(value)) {
      data[field] = fromDocumentData(value);
    } else if (isObject(value)) {
      data[field] = fromDocumentData(value);
    }
  });

  return data;
}

export function getErrorCode(
  className: string,
  defaultCode: string,
  error?: any
) {
  return error && error instanceof FirebaseError
    ? error.code.replace(`${className}/`, "")
    : defaultCode;
}
